import { api } from "services";

import { resToCategory } from "./transformations";
import { Category } from "./types";

export const getCategories = async (): Promise<Category[]> => {
  const res = await api.get("/categories");
  return res.data.map(resToCategory);
};
